module.exports = __webpack_public_path__ + "img/pdfIcon.95c9c4bf.svg";